import type { ReactNode } from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { InputField } from '@nesso/ui/primitives/input-field';

type PersonNameFormValues = {
    firstName: string;
    lastName: string;
};

// The row is the subgrid of a parent that declares its columns (name, name — or name, initial, name
// with a `middleInitial`), so the caller's other fields can line up under the same tracks.
type Props = {
    maxLength: number;
    middleInitial?: ReactNode;
};

export function PersonNameFields({ maxLength, middleInitial }: Props) {
    const {
        control,
        formState: { isSubmitting },
    } = useFormContext<PersonNameFormValues>();

    return (
        <div className="grid grid-cols-1 gap-y-4 md:col-span-full md:grid-cols-subgrid">
            <div>
                <Controller
                    control={control}
                    name="firstName"
                    render={({ field, fieldState }) => (
                        <InputField
                            {...field}
                            id={field.name}
                            label="Legal first name"
                            disabled={isSubmitting}
                            maxLength={maxLength}
                            error={fieldState.error?.message ?? fieldState.invalid}
                        />
                    )}
                />
            </div>
            {middleInitial && <div className="w-10">{middleInitial}</div>}
            <div>
                <Controller
                    control={control}
                    name="lastName"
                    render={({ field, fieldState }) => (
                        <InputField
                            {...field}
                            id={field.name}
                            label="Legal last name"
                            disabled={isSubmitting}
                            maxLength={maxLength}
                            error={fieldState.error?.message ?? fieldState.invalid}
                        />
                    )}
                />
            </div>
        </div>
    );
}
